import React from 'react';
import styles from './BtnSecondary.module.scss'

const BtnSecondary = ({children, onClick, styleDiv, styleSpan, disabled}) => {
    const handleClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };

    return (
        <div className={`${styles.btnSecondary} ${disabled ? styles.disabled : ''}`} onClick={handleClick} onTouchEnd={handleClick} style={styleDiv}><span style={styleSpan}>{children}</span></div>
    );
};

export default BtnSecondary;
